import React, {useEffect} from 'react';
import Comment from "components/input/Comment.component";
import OKCancelButtons from "components/modals/OKCancelButtons";
import {MODAL_CONTENT_TAB_INDEX} from "utils/constants";

const Reject = ({more, translate, closeModal, loopFocus}: any): React.ReactElement => {

    const commentInputRef = React.createRef<HTMLTextAreaElement>();
    const [comment, setComment] = React.useState("");


    const keepFocus = () => {
        commentInputRef.current?.focus();
    };

    useEffect(() => {
        keepFocus();
    }, []);


    const okEnabled = true;
    return (
        <div>
            <h4 className="modal-title">
                {more?.title || translate("popUp.reject.title")}
            </h4>
            <div className="modal-body">
                <Comment ref={commentInputRef}
                         inputHint={translate("popUp.reject.commentHint")}
                         translate={translate}
                         tabIndex={MODAL_CONTENT_TAB_INDEX}
                         id="comment"
                         shouldFocusFirst={true}
                         propagateValue={value => setComment(value)}
                         value={comment}
                         label={translate("popUp.reject.commentLabel")}
                         labelState={`(${translate("popUp.required")})`}
                />
            </div>
            <OKCancelButtons
                tabIndex={MODAL_CONTENT_TAB_INDEX + 1}
                okEnabled={okEnabled}
                okCallback={closeModal}
                okText={translate("popUp.reject.rejectTask")}
                cancelEnabled={true}
                cancelCallback={closeModal}
                cancelText={translate("popUp.close")}
                loopFocus={loopFocus}
            />
        </div>
    )
}

export default Reject;